import {
  SET_CURRENT_USER,
  PASSWORD_VERIFY_SUCCESS,
  UNSET_CURRENT_USER,
  PASSWORD_RESET_RES
} from './types.js';
import service from '../providers/service.js';
import BrowserHistory from '../providers/BrowserHistory.js';
import { generateUserProfile } from "../helpers/user.js";
import { setErrors } from "./error.js";
// Helper functions to dispatch actions, optionally
// with payloads for authentication

// Authenticate
export function authenticate(email, password) {

  return (dispatch) => {
    service.post('/api/auth', { email: email, password: password }).then(response => {
      if (response.data.user) {
        dispatch(setErrorMsg(false))
        // modify the user object a bit
        const user = generateUserProfile(response, true);
        // Save token & user to redux store
        console.log(user)
        dispatch(setCurrentUser(user));

        // Redirect to /main
        BrowserHistory.push('/main');
      }

      // if (response.data.errors) {
      //   dispatch(setErrors(response.data.errors));
      // }
    }).catch((err) => {
        dispatch(setErrorMsg(true))
        console.log(err)
    })
  };
}

// verify password
export function verifyPassword(email, password) {
  return (dispatch) => {
    service
      .post('/api/auth/verify', { email: email, password: password })
      .then(response => {
        if (response.data.result) {
          dispatch(setPasswordVerify(response.data.result));
        } else {
          dispatch(setPasswordVerify(response.data.result));
          // Display error?
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
        }
      }).catch((err) => {
        dispatch(setErrors(err.response.data.errors))
      })
  };
}

/**
 * Send a password reset request
 * @param {string} email 
 */
export function passwordResetRequest(email) {
  return (dispatch) => {
    service
      .post('/api/auth/password-reset', { email })
      .then(response => {
        if (response.data.result) {
          dispatch(setPasswordResetRes(response.data.result));
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
          alert('An error has occured! Please, check the email!');
        }
      }).catch((err) => {
        dispatch(setErrors(err.response.data.errors));
        alert('An error has occured! Please, check the email!');
      })
  };
}

/**
 * Send a password update request to api
 * @param {string} token 
 * @param {string} password 
 * @param {string} password_confirmation 
 */
export function passwordUpdateRequest(token, password, password_confirmation) {
  return dispatch => {
    service
      .post(`/api/auth/password-update/${token}`, { password, password_confirmation })
      .then(response => {
        if (response.data.result) {
          switch (response.data.result) {
            case 'password_reset.user_not_found':
              alert('Invalid token! Please, start the procedure over');
              return BrowserHistory.push('/forgot-password');
            case 'password_reset.success':
              alert('The password has been updated! You can now log in with your renewed credentials!');
              return BrowserHistory.push('/login');
            default:
              alert('Unknown response');
              break;
          }
        }

        if (response.data.errors) {
          dispatch(setErrors(response.data.errors));
          alert('An error has occured! Please, check the passwords!');
        }
      }).catch((err) => {
        dispatch(setErrors(err.response.data.errors));
        alert('An error has occured! Please, check the passwords!');
      })
  }
}

// Update user, set passwordVerified to true/false
export function setPasswordVerify(val) {
  return { type: PASSWORD_VERIFY_SUCCESS, val: val };
}

/**
 * Save password reset request result to state
 * @param {string} res 
 */
export function setPasswordResetRes(res) {
  return { type: PASSWORD_RESET_RES, res };
}

// Save user to redux store
export function setCurrentUser(user) {
  return {
    type: SET_CURRENT_USER,
    user: user
  };
}

export function setErrorMsg(error) {
  return {
    type: 'SET_ERROR',
    payload: error
  }
}

// Remove user from redux store
export function unsetCurrentUser(id) {
  return {
    type: UNSET_CURRENT_USER,
    id: id
  };
}

// Signout
export function signout() {
  return (dispatch, getState) => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    dispatch(unsetCurrentUser(getState().user.id));
    BrowserHistory.push('/');
  }
}


// WEBPACK FOOTER //
// ./src/actions/auth.js